module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("To Renee Ann Benally")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("You are gone but not forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("Your family is forever in NK Tribe Called Success’ prayers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("To my Native American brothers and sisters, we are kindred spirits.  My book was released during the month of November, which is also Native American Heritage Month.  What a fitting way to bring attention to the growing plight of homelessness in the indigenous community.  Together we can develop viable solutions to reaffirm our humanity.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0